import React from 'react';

import { ScanStatus } from '../../../types/enumTypes';

type Props = {
    scanStatus?: ScanStatus | null
};

export const isDocumentAvailableForScanStatus = (scanStatus?: ScanStatus | null): boolean =>
    scanStatus === undefined
    || scanStatus === null
    || scanStatus === ScanStatus.Clean
    || scanStatus === ScanStatus.Legacy;

const ScanStatusBadge: React.FC<Props> = ({ scanStatus }) => {
    switch (scanStatus) {
        case ScanStatus.Pending:
            return (
                <span className="scan-status-badge scan-status-badge--pending" data-tooltip="This file is being scanned for viruses and is not available yet.">
                    <i className="fas fa-circle-notch fa-spin" aria-hidden="true" />
                    Scanning
                </span>
            );
        case ScanStatus.Infected:
            return (
                <span className="scan-status-badge scan-status-badge--infected" data-tooltip="This file was blocked because a virus was detected.">
                    <i className="fas fa-exclamation-triangle" aria-hidden="true" />
                    Infected
                </span>
            );
        case ScanStatus.Clean:
        case ScanStatus.Legacy:
        default:
            // Clean and Legacy documents are available and need no badge; the same holds for a missing status (null/undefined).
            return null;
    }
};

export default ScanStatusBadge;
